import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/landing/Navbar";
import { Hero } from "./components/landing/Hero";
import { StatsBar } from "./components/landing/StatsBar";
import { WhatIs } from "./components/landing/WhatIs";
import { Advantages } from "./components/landing/Advantages";
import { NationalCarousel, IntlCarousel } from "./components/landing/Carousels";
import { AliveApp } from "./components/landing/AliveApp";
import { HowTo } from "./components/landing/HowTo";
import { FAQ } from "./components/landing/FAQ";
import { FinalCTA, Footer } from "./components/landing/FinalCTA";
import SmartCampus from "./pages/SmartCampus";
import Arcca from "./pages/Arcca";

const LandingPage = () => (
  <div className="bg-white text-zinc-900 antialiased">
    <Navbar />
    <main>
      <Hero />
      <StatsBar />
      <WhatIs />
      <Advantages />
      <NationalCarousel />
      <IntlCarousel />
      <AliveApp />
      <HowTo />
      <FAQ />
      <FinalCTA />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/smart" element={<SmartCampus />} />
        <Route path="/arcca" element={<Arcca />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
